import { getEntryPath } from "../../accessRoles.js";
import { useState } from "react";
import { Typography, Button, Form, Input, Alert } from "antd";
import { Link, useNavigate } from "react-router-dom";
import { LockOutlined, UserOutlined } from "@ant-design/icons";
import { request, saveAuthTokenInLocalStorage } from "../../axios_helper.js";
import { getRoleFromAuthToken } from "../../jwt_helper.js";

const { Title } = Typography;

export default function Login({ embedded = false, initialCredentials, onCredentialsChange }) {
  const navigate = useNavigate();
  const [errorText, setErrorText] = useState(null);

  const onFinish = (values) => {
    setErrorText(null);
    request("POST", "/api/v1/auth/authenticate", false, {
      username: values.username,
      password: values.password,
    }).then((response) => {
      if (response?.status === 200) {
        saveAuthTokenInLocalStorage(response.data.jwt);
        window.location.href = getEntryPath(getRoleFromAuthToken());
        //navigate("/");
      } else if (response?.data?.errorType === "EMAIL_NOT_VERIFIED") {
        navigate("/home/verify-email-pending", { state: { username: values.username } });
      } else {
        setErrorText(response?.data?.message ?? "Sign in failed");
      }
    });
  };

  return (
    <div style={{ margin: "auto", width: embedded ? "100%" : "200px" }}>
      {!embedded && <Title style={{ textAlign: "center" }}>Sign in</Title>}
      <Form name="login" initialValues={{ remember: true, username: initialCredentials?.username, password: initialCredentials?.password }}
        onValuesChange={(_, values) => onCredentialsChange?.({ username: values.username, password: values.password })} onFinish={onFinish}>
        {errorText !== null && errorText !== undefined && <Alert style={{ marginBottom: "10px" }} message={errorText.length > 0 ? errorText : "Sign in failed"} type="error" showIcon />}
        <Form.Item name="username" rules={[{ required: true, message: "Please input your Username" }]}>
          <Input prefix={<UserOutlined />} placeholder="Username" />
        </Form.Item>
        <Form.Item name="password" rules={[{ required: true, message: "Please input your Password" }]}>
          <Input prefix={<LockOutlined />} type="password" placeholder="Password" />
        </Form.Item>

        <Form.Item>
          <Button block type="primary" htmlType="submit">
            Sign in
          </Button>
          {embedded ? <Link className="landing-auth-secondary" to="/?auth=register">Create account</Link> : <>or <Link to="/home/register">Create account</Link></>}
          <Button block type="link" style={{ marginTop: "8px" }} onClick={() => navigate("/home/forgot-password")}>Forgot password?</Button>
        </Form.Item>
      </Form>
    </div>
  );
}
